import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from '../common/FadeIn';
import webDevImg from '../../assets/images/webDevelopment.png';

const deliverablesLeft = [
  "Complete website personalization",
  "Content replacement",
  "Image and video updates",
  "Brand colors",
];

const deliverablesRight = [
  "Contact information setup",
  "Mobile-friendly design",
  "Domain connection",
  "Website launch",
];

const ServiceDetailSection = () => {
  return (
    <section className="w-full bg-[#f9f9f5] text-[#1C1917] flex flex-col justify-center overflow-hidden">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 items-stretch">

        <div className="w-full h-full min-h-[320px] sm:min-h-[420px] lg:min-h-full self-stretch bg-[#EAE5DD] flex items-center justify-center relative overflow-hidden">
          <img
            src={webDevImg}
            alt="Custom Website Development & Customization Studio"
            className="w-full h-full object-cover object-center"
            loading="lazy"
            decoding="async"
            width="600"
            height="800"
          />
        </div>

        <div className="w-full bg-[#f9f9f5] flex flex-col justify-center p-6 sm:p-10 md:p-12 lg:p-16">
          <div className="max-w-[540px]">

            <FadeIn>
              <h2 className="font-saolDisplayItalic md:text-[70px] text-[40px] leading-[1] font-normal tracking-[0em] mb-7 sm:mb-9">
                Website Customization
              </h2>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-black leading-[1.6] tracking-[0em] mb-6">
                Make the design yours.
              </p>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-black leading-[1.6] tracking-[0em] mb-6">
                Choose a website design from my collection, and I will customize it with your content, images, logo, colors, videos, and business details.
                <br /><br />
                I will make sure everything looks right, works well on all devices, and is ready to launch.
              </p>
            </FadeIn>

            <FadeIn>
              <div className="border-b border-[#E0D8CE] pb-3 mb-6">
                <span className="font-interDisplayMedium text-[10px] sm:text-[11px] uppercase tracking-[0.2em] font-semibold text-[#8B8477]">
                  WHAT'S INCLUDED
                </span>
              </div>
            </FadeIn>

            <FadeIn>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 text-[13px] sm:text-[14px] font-interDisplayMedium font-light text-[#4A433A] leading-[1.7] mb-8 sm:mb-10">
                <div className="space-y-2">
                  {deliverablesLeft.map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <span className="text-[#8B8477] text-[10px]">•</span>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
                <div className="space-y-2">
                  {deliverablesRight.map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <span className="text-[#8B8477] text-[10px]">•</span>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </FadeIn>

            <FadeIn>
              <div className="pt-4 border-t border-[#E8E2D9]">
                <Link
                  to="/inquiry"
                  className="bg-[#ce884d] text-[#ffffff] font-montserratMedium text-[9px] lg:text-[11px] font-semibold leading-[1] tracking-[0.06em] cursor-pointer duration-[0.5s] hover:bg-[#ccc3ad] hover:text-black w-[200px] h-[50px] md:w-[201px] md:h-[54px] inline-flex items-center justify-center text-center uppercase"
                >
                  INQUIRE NOW
                </Link>
              </div>
            </FadeIn>

          </div>
        </div>

      </div>
    </section>
  );
};

export default ServiceDetailSection;
